/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllStateResponseDto
 */
export interface AllStateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AllStateResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AllStateResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AllStateResponseDto
     */
    iso: string;
    /**
     * 
     * @type {string}
     * @memberof AllStateResponseDto
     */
    countryCode: string;
}

/**
 * Check if a given object implements the AllStateResponseDto interface.
 */
export function instanceOfAllStateResponseDto(value: object): value is AllStateResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('iso' in value) || value['iso'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function AllStateResponseDtoFromJSON(json: any): AllStateResponseDto {
    return AllStateResponseDtoFromJSONTyped(json, false);
}

export function AllStateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllStateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'iso': json['iso'],
        'countryCode': json['countryCode'],
    };
}

export function AllStateResponseDtoToJSON(json: any): AllStateResponseDto {
    return AllStateResponseDtoToJSONTyped(json, false);
}

export function AllStateResponseDtoToJSONTyped(value?: AllStateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'iso': value['iso'],
        'countryCode': value['countryCode'],
    };
}

